import React from "react";
import {
  Box,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import {
  ChevronLeft,
  ChevronRightOutlined,
  HomeOutlined,
  ShoppingCartOutlined,
  Groups2Outlined,
  ReceiptLongOutlined,
  PublicOutlined,
  PointOfSaleOutlined,
  TodayOutlined,
  CalendarMonthOutlined,
  AdminPanelSettingsOutlined,
  TrendingUpOutlined,
  PieChartOutlined,
  ExpandLess,
  ExpandMore,


  Person as PersonIcon,
  Code as CodeIcon,
  Work as WorkIcon,
  School as SchoolIcon,
  AttachMoney as AttachMoneyIcon,
  Warning as WarningIcon,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FlexBetween from "./FlexBetween";


const navItems = [
  {
    text: "Dashboard",
    icon: <HomeOutlined />,
  },
  {
    text: "Products",
    icon: null,
  },
  {
    text: "Time Management",
    icon: <ShoppingCartOutlined />,
    subItems: [
      {
        text: "Users",
        icon: <PersonIcon />,
      },
      {
        text: "Shifts",
        icon: <WorkIcon />,
      },
      {
        text: "Shifts11",
        icon: <WorkIcon />,
      },
      {
        text: "Clocks",
        icon: <TodayOutlined />,
      },
      {
        text: "Availability",
        icon: <PersonIcon />,
      },
      {
        text: "Time Off Requests",
        icon: <WorkIcon />,
      },
      {
        text: "Weekly Hours",
        icon: <TodayOutlined />,
      },
      {
        text: "Labor Costing",
        icon: <AttachMoneyIcon />,
      },
      {
        text: "Overtime Exceptions",
        icon: <WarningIcon />,
      },
      {
        text: "Productivity Analytics",
        icon: <TrendingUpOutlined />,
      },
      {
        text: "Holidays",
        icon: <TodayOutlined />,
      },
      {
        text: "Footprints",
        icon: <PublicOutlined />,
      },
    ],
  },
  {
    text: "Portfolio",
    icon: <ShoppingCartOutlined />,
    subItems: [
      {
        text: "Personal Info",
        icon: <PersonIcon />,
      },
      {
        text: "Skills",
        icon: <CodeIcon />,
      },
      {
        text: "Projects",
        icon: <WorkIcon />,
      },
      {
        text: "Experiences",
        icon: <WorkIcon />,
      },
      {
        text: "Education",
        icon: <SchoolIcon />,
      },
    ],
  },


  
  {
    text: "Soles",
    icon: null,
  },
  {
    text: "Customers",
    icon: <Groups2Outlined />,
  },
  {
    text: "Transactions",
    icon: <ReceiptLongOutlined />,
  },
  {
    text: "Geography",
    icon: <PublicOutlined />,
  },
  {
    text: "MA",
    icon: null,
  },
  {
    text: "Overview",
    icon: <PointOfSaleOutlined />,
  },
  {
    text: "Daily",
    icon: <TodayOutlined />,
  },
  {
    text: "Monthly",
    icon: <CalendarMonthOutlined />,
  },
  {
    text: "Breakdown",
    icon: <PieChartOutlined />,
  },
  {
    text: "Management",
    icon: null,
  },
  {
    text: "Admin",
    icon: <AdminPanelSettingsOutlined />,
    subItems: [
      {
        text: "Administrators",
        icon: <ShoppingCartOutlined />,
      },
      {
        text: "Footprints",
        icon: <ShoppingCartOutlined />,
      },
    ],
  },
  {
    text: "Performance",
    icon: <TrendingUpOutlined />,
  },
];

const Sidebar = ({
  user,
  drawerWidth,
  isSidebarOpen,
  setIsSidebarOpen,
  isNonMobile,
}) => {
  const { pathname } = useLocation();
  const [active, setActive] = useState("");
  const [open, setOpen] = useState({});
  const navigate = useNavigate();
  const theme = useTheme();

  useEffect(() => {
    setActive(pathname.substring(1));
  }, [pathname]);

  const handleDropdownClick = (text) => {
    setOpen(prevOpen => ({ ...prevOpen, [text]: !prevOpen[text] }));
  };

  return (
    <Box component="nav">
      {isSidebarOpen && (
        <Drawer
          open={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          variant="persistent"
          anchor="left"
          sx={{
            width: drawerWidth,
            "& .MuiDrawer-paper": {
              color: theme.palette.secondary[200],
              backgroundColor: theme.palette.background.alt,
              boxSixing: "border-box",
              borderWidth: isNonMobile ? 0 : "2px",
              width: drawerWidth,
            },
          }}
        >
          <Box width="100%">
            <Box m="1.5rem 2rem 2rem 3rem">
              <FlexBetween color={theme.palette.secondary.main}>
                <Box display="flex" alignItems="center" gap="0.5rem">
                  <Typography variant="h4" fontWeight="bold">
                    IBRAHIM
                  </Typography>
                </Box>
                {!isNonMobile && (
                  <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                    <ChevronLeft />
                  </IconButton>
                )}
              </FlexBetween>
            </Box>
            <List>
              {navItems.map(({ text, icon, subItems }) => {
                if (!icon) {
                  return (
                    <Typography key={text} sx={{ m: "2.25rem 0 1rem 3rem" }}>
                      {text}
                    </Typography>
                  );
                }
                const lcText = text.toLowerCase();

                if (subItems) {
                  return (
                    <React.Fragment key={text}>
                      <ListItem disablePadding>
                        <ListItemButton onClick={() => handleDropdownClick(text)}>
                          <ListItemIcon sx={{ ml: "2rem" }}>
                            {icon}
                          </ListItemIcon>
                          <ListItemText primary={text} />
                          {open[text] ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                      </ListItem>
                      <Collapse in={open[text]} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                          {subItems.map((sub) => (
                            <ListItemButton
                              key={sub.text}
                              onClick={() => {
                                navigate(`/${text.toLowerCase()}/${sub.text.toLowerCase()}`);
                                setActive(`${text.toLowerCase()}/${sub.text.toLowerCase()}`);
                              }}
                              sx={{
                                pl: "3rem",
                                backgroundColor:
                                  active === `${text.toLowerCase()}/${sub.text.toLowerCase()}`
                                    ? theme.palette.secondary[300]
                                    : "transparent",
                                color:
                                  active === `${text.toLowerCase()}/${sub.text.toLowerCase()}`
                                    ? theme.palette.primary[600]
                                    : theme.palette.secondary[100],
                              }}
                            >
                              <ListItemIcon sx={{
                                ml: "1rem",
                                color:
                                  active === `${text.toLowerCase()}/${sub.text.toLowerCase()}`
                                    ? theme.palette.primary[600]
                                    : theme.palette.secondary[200],
                              }}>
                                {sub.icon}
                              </ListItemIcon>
                              <ListItemText primary={sub.text} />
                              {active === lcText && (
                                <ChevronRightOutlined sx={{ ml: "auto" }} />
                              )}
                            </ListItemButton>
                          ))}
                        </List>
                      </Collapse>
                    </React.Fragment>
                  );
                }

                return (
                  <ListItem key={text} disablePadding>
                    <ListItemButton
                      onClick={() => {
                        navigate(`/${lcText}`);
                        setActive(lcText);
                      }}
                      sx={{
                        backgroundColor:
                          active === lcText
                            ? theme.palette.secondary[300]
                            : "transparent",
                        color:
                          active === lcText
                            ? theme.palette.primary[600]
                            : theme.palette.secondary[100],
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          ml: "2rem",
                          color:
                            active === lcText
                              ? theme.palette.primary[600]
                              : theme.palette.secondary[200],
                        }}
                      >
                        {icon}
                      </ListItemIcon>
                      <ListItemText primary={text} />
                      {active === lcText && (
                        <ChevronRightOutlined sx={{ ml: "auto" }} />
                      )}
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Box>

          
        </Drawer>
      )}
    </Box>
  );
};

export default Sidebar;
